// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  DefaultPage,
  BasePage,
  QPGodsPage,
  PlanPage
} from './';

export default {
  path: 'furui',
  name: 'Furui',
  childRoutes: [
    { path: 'default-page', name: 'Default page', component: DefaultPage, isIndex: true },
    { path: 'base' , name: 'base' , component: BasePage , isIndex:false },
    { path: 'qpgoods' , name: 'qpgoods' , component: QPGodsPage , isIndex:false},
    { path: 'plan' , name: 'plan' , component: PlanPage , isIndex:false}
  ],
};



// WEBPACK FOOTER //
// ./src/features/furui/route.js